<template>
     <div>
        <h5 class="text-uppercase mt-20">Recover Password</h5>
        <p>Kindly enter your email to receive a reset link</p>
        <form class="form-type-line">
            <div class="form-group">
                <label for="email">Email</label>
                <input type="text" class="form-control" id="email" @blur="$v.email.$touch()" v-model="email">
                <div v-if="$v.email.$dirty">
                    <div class="custom-error" v-if="!$v.email.required">*Your email address is required.</div>
                    <div class="custom-error" v-if="!$v.email.email">*Please enter a valid email address.</div>
                </div>
            </div>

            <div class="form-group">
                <button class="btn btn-bold btn-block btn-primary" disabled v-if="loading">
                    <circle-spin class="m-0"></circle-spin>
                </button>
                <button class="btn btn-bold btn-block btn-primary" type="button" v-else :disabled="$v.$invalid" @click="sendEmail">Send Reset Link</button>
            </div>
        </form>
            <p class="text-center text-muted fs-13 mt-20">
              <a class="text-primary fw-700" href="#" @click="backToLogin">Back to Login</a>
            </p>
  </div>
</template>

<script>
import axios from 'axios'
import { required, email } from "vuelidate/lib/validators";

export default {
    props: ['login'],
    data() {
        return {
            loading: false,
            email: ''
        }
    },
    validations: {
        email: {
        required,
        email
        }
    },
    methods:{
        backToLogin() {
            this.$emit('backToLogin')
        },
        sendEmail() {
            this.loading = true
            let userData = {
                email: this.email
            }
            axios.post('/users/reset/password', userData)
            .then(res => {
                this.loading= false
                this.$notify({
                    group: 'response',
                    type: 'success',
                    title:`Reset Link sent. ${res.data.data}`,
                    duration: 2500,
                });
                setTimeout(() => {
                    this.$router.push('/')
                }, 3000)
            })
            .catch(err => {
                this.loading= false
                // console.log(err)
                this.$notify({
                group: 'response',
                type: 'error',
                title: 'Failed to send email. Please try again',
                duration: 5000       
                });
            })
        }
    }
}
</script>